import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../hooks';
import { getCustomerPortal } from '../../store/StripeSlice';
import { getAuthState } from '../../store/AuthSlice';

import FullScreenLoader from '../../components/Loaders/FullScreenloader';

const ManageSubscriptions: React.FC = () => {
  const dispatch = useDispatch();

  // Store
  const authState = useAppSelector(getAuthState);

  useEffect(() => {
    if (authState.user && authState.user._id) {
      dispatch(getCustomerPortal(authState.user._id));
    }
  }, []);

  return <FullScreenLoader />;
};

export default ManageSubscriptions;
